module.exports = __webpack_public_path__ + "img/a2hs_ios.60112329.png";